import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const ThreeNav = () => import('@/views/ThreeNav')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')

const SixNav = () => import('@/views/AssistiveDevice')
const Demo = () => import('@/views/Demo')
const HotNursingHome = () => import('@/components/nursingHome/index.vue')
const ReportList = () => import('@/components/report_list/index.vue')
const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const Realize = () => import('@/components/realize/index.vue')

const AssistiveDevice = () => import('@/components/assistive_device/index.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/production',
    component:Production,
    children:[
      {
        path:'1',
        component:HotNursingHome
      },
    ]
  },
  {
    path:'/threenav',
    component:ThreeNav
  },
  {
    path:'/fournav',
    component:FourNav,
    children:[
      {
        path:'1',
        component:ReportList
      },
      {
        path:'2',
        component:ReportList
      },
      {
        path:'3',
        component:ReportList
      },
    ]
  },
  {
    path:'/assistiveDevice',
    component: SixNav,
    children:[
      {
        path:'1',
        component:AssistiveDevice
      },
      {
        path:'2',
        component:AssistiveDevice
      },
      {
        path:'3',
        component:ReportList
      },
    ]
  },  
  {
    path:'/fivenav',
    component:FiveNav,
    children:[
      {
        path:'1',
        component:Realize
      },
    ]
  },
  {
    path:'/demo',
    component:Demo
  },
  {
    path:'/news_detail/1',
    component:NewsDetails
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router